<script setup lang="ts">
/* FAToggleButton mimic's primevue's ToggleButton but uses slots so it can work
with font-awesome (FA)
*/
const emit = defineEmits(["update:modelValue", "change"]);

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false
  },
  modelValue: {
    type: Boolean,
    required: true
  }
});

const onClick = (e: Event) => {
  if (!props.disabled) {
    emit("update:modelValue", !props.modelValue);
    emit("change", e);
  }
};
</script>

<template>
  <div
    class="fa-toggle"
    :class="{ isDisabled: props.disabled, isChecked: props.modelValue }"
    role="checkbox"
    :aria-checked="modelValue"
    data-cy="fa-toggle"
    @click="onClick($event)"
  >
    <slot
      name="default"
      :is-disabled="disabled"
      :model-value="modelValue"
    ></slot>
  </div>
</template>

<style lang="scss">
.fa-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5em;
  border-radius: var(--border-radius);
  border: 2px solid var(--surface-400);
  color: var(--text-color);
  outline: none;

  &:hover:not(.isDisabled) {
    box-shadow: var(--shadow-info);
  }

  &.isChecked {
    border-color:  var(--info-500);
    background: var(--info-800);
    color: var(--info-100);
    &:hover:not(.isDisabled) {
      background: var(--info-200);
    }
  }

  &.isDisabled {
    background: var(--surface-400);
    color: var(--surface-50);
    &:hover {
      background: var(--surface-400);
    }
  }
}
</style>
